<div>
    <ng-content select="[content]"></ng-content>
    <button mat-icon-button color="primary" (click)="showDialog()">
        <mat-icon>zoom_out_map</mat-icon>
    </button>
</div>
